export default __webpack_public_path__ + "media/images/ui-icons_777620_256x240-4e7e3e142f3939883cd0a7e00cabdaef.png";